
import { BasicButton } from "@goodgamestudios/asset-globals";
import { BasicController } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { MathBase } from "@goodgamestudios/core";
import { DictionaryUtil } from "@goodgamestudios/core";
import { URLRequest } from "@goodgamestudios/createjs-utilities";
import { Loader } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { Balancing } from "../../constants/shared/Balancing";
import { Poker2SoundController } from "../../controller/Poker2SoundController";
import { Poker2BuddyEvent } from "../../event/Poker2BuddyEvent";
import { BuddyVO } from "../../gamevo/BuddyVO";
import { Poker2Model } from "../../model/Poker2Model";
import { PokerTextHelper } from "./PokerTextHelper";
import { TweenLite } from "gsap";
import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;

export class TableFriendHelper {
    private static CARD_INFO_START_Y: number = 0;
    private static CARD_BUTTON_START_Y: number;
    private static NOPIC_PATTERN: RegExp;
    private static AVATAR_SCALE_FACTOR: number = 0.5;
    private CITEM_HEIGHT: number = 55;
    private friendkomponent: MovieClip;
    private currentX: number = 0;
    private maxX: number = 0;

    constructor(komponent: MovieClip) {
        this.friendkomponent = komponent;
        this.friendkomponent.addEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
    }

    private onClick(event: MouseEvent): void {
        if (event.target instanceof BasicButton && !event.target.enabled)
            return;
        var tempX: number = this.currentX;

        switch (event.target) {
            case this.friendkomponent.btn_left:
                this.currentX = int(MathBase.max(0, this.currentX - 146));
                break;
            case this.friendkomponent.btn_right:
                this.currentX = int(MathBase.min(this.maxX, this.currentX + 146));
                break;

        }

        if (this.currentX != tempX) {
            BasicController.getInstance().soundController.playSoundEffectByName(Poker2SoundController.SND_CLICK);
            this.friendkomponent.btn_left.enableButton = false;
            this.friendkomponent.btn_right.enableButton = false;
            TweenLite.to(this.friendkomponent.mc_holder, 0.5, { x: -this.currentX, onComplete: this.bindFunction(this.onCompleteTween) });
        }
    }

    private onCompleteTween(): void {
        this.friendkomponent.btn_left.enableButton = true;
        this.friendkomponent.btn_right.enableButton = true;
    }

    public init(): void {
        this.currentX = 0;
        this.maxX = 0;
        this.onUpdateFriends();
    }

    public onUpdateFriends(event: Poker2BuddyEvent = null): void {
        this.maxX = 0;

        while (this.friendkomponent.mc_holder.numChildren > 0)
            this.friendkomponent.mc_holder.removeChildAt(0);

        if (Poker2Model.onTableData.currentTable == null || Poker2Model.onTableData.currentTable.seats == null)
            return;
        var friendList: Map<any, any> = new Map<any, any>();

        for (let entryList of Poker2Model.onTableData.currentTable.seats) {
            var seatVO: any = entryList;
            if (seatVO === undefined) continue;

            if (seatVO && Poker2Model.buddyList.isBuddyByPlayerId(seatVO.playerId) && seatVO.playerId != Poker2Model.userData.playerID)
                friendList.set(seatVO.playerId, Poker2Model.buddyList.getBuddyByPlayerId(seatVO.playerId));
        }
        var friendListArray: any[] = DictionaryUtil.getValues(friendList);

        for (var i: number = 0; i < friendListArray.length; i++) {
            var buddyVO: BuddyVO = friendListArray[i] as BuddyVO;
            var friendCard: Library.PokerFriendsPanel.FriendCard = new Library.PokerFriendsPanel.FriendCard();
            friendCard.x = (friendCard.width + 5) * i;

            friendCard.mc_cardinfo.y = TableFriendHelper.CARD_INFO_START_Y;
            //friendCard.mc_cardbutton.y = CARD_BUTTON_START_Y;
            friendCard.mc_cardinfo.mouseChildren = false;
            friendCard.btn_addfriend.visible = false;

            friendCard.mc_cardinfo.txt_level.text = String(Balancing.calcLevelFromXP(buddyVO.playerXp));
            TextFieldHelper.changeTextFromatSizeByTextWidth(9, friendCard.mc_cardinfo.txt_name, buddyVO.playerName);
            TextFieldHelper.changeTextFromatSizeByTextWidth(9, friendCard.mc_cardinfo.txt_chips, PokerTextHelper.getShortGroupNumberString(buddyVO.cashTotal));
            friendCard.buddyData = buddyVO;

            while (friendCard.mc_cardinfo.mc_holder.numChildren > 0)
                friendCard.mc_cardinfo.mc_holder.removeChildAt(0);

            friendCard.mc_cardinfo.mc_holder.mouseChildren = false;

            if (buddyVO.thumbUrl && buddyVO.thumbUrl != "" && buddyVO.thumbUrl.search(TableFriendHelper.NOPIC_PATTERN) == -1) {
                var loader: Loader = new Loader();
                var request: URLRequest = new URLRequest(buddyVO.thumbUrl);
                loader.load(request);
                loader.contentLoaderInfo.addEventListener(Event.COMPLETE, this.bindFunction(this.onPicLoadComplete));
                friendCard.mc_cardinfo.mc_holder.addChild(loader);
            }
            else {
                var buddyMC: Container = AvatarHelper.drawAvatarByItemArray(Poker2Model.avatarData.getAvatarClothesArray(buddyVO.avatarVO));
                var bounds: Rectangle = buddyMC.getBounds(null);
                buddyMC.x = -((bounds.width * TableFriendHelper.AVATAR_SCALE_FACTOR) / 2 + (bounds.left * TableFriendHelper.AVATAR_SCALE_FACTOR));
                buddyMC.y = -(bounds.top * TableFriendHelper.AVATAR_SCALE_FACTOR + 5);
                buddyMC.scaleX = buddyMC.scaleY = TableFriendHelper.AVATAR_SCALE_FACTOR;
                friendCard.mc_cardinfo.mc_holder.addChild(buddyMC);
            }
            this.friendkomponent.mc_holder.addChild(friendCard);
            this.maxX = int(MathBase.max(0, (friendCard.width + 5) * (friendListArray.length - 1)));
        }
    }

    private onPicLoadComplete(event: Event): void {
        event.target.removeEventListener(Event.COMPLETE, this.bindFunction(this.onPicLoadComplete));
        var gfx: Loader = event.target.loader;
        var bounds: Rectangle = gfx.getBounds(null);

        var userPicScale: number = this.CITEM_HEIGHT / bounds.height;
        gfx.scaleX = gfx.scaleY = userPicScale;
        gfx.y = -10;
        gfx.x = -bounds.width * userPicScale / 2;
    }

    public destory(): void {
        this.friendkomponent.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
    }

    public static __initialize_static_members() {
        TableFriendHelper.CARD_BUTTON_START_Y = int(86.8);
        TableFriendHelper.NOPIC_PATTERN = new RegExp("nopic", "i");
    }
}
import { AvatarHelper } from "./AvatarHelper";

TableFriendHelper.__initialize_static_members();

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
